import Delete from "@mui/icons-material/Delete";
import Autocomplete from "@mui/material/Autocomplete";
import Grid2 from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { getFieldPath } from "../../Common/SchemaUtils";

const getEnumFormField = (enum_values: string[]) => {
  const EnumFormFields: React.FC<{
    extractionId: string;
    extractionPath?: string;
    label?: string;
    remove?: Function;
  }> = ({ extractionId, extractionPath, label, remove }) => {
    const { control } = useFormContext();
    return (
      <Grid2 container spacing={2} sx={{ alignItems: "center" }}>
        <Grid2 size={remove !== undefined ? 11 : 12}>
          <Controller
            render={({ field: { onChange, ...props } }) => (
              <Autocomplete
                disablePortal
                options={enum_values}
                renderInput={(params) => (
                  <TextField {...params} size="small" label={label} />
                )}
                onChange={(e, v) => onChange(v)}
                {...props}
              />
            )}
            name={`extraction.${getFieldPath([
              extractionId,
              "value",
              extractionPath,
            ])}`}
            control={control}
          />
        </Grid2>
        {remove !== undefined && (
          <Grid2 size={1} sx={{ textAlign: "right" }}>
            <IconButton
              onClick={() => {
                remove();
              }}
              className="rounded-full"
              size="small"
            >
              <Delete color="error" />
            </IconButton>
          </Grid2>
        )}
      </Grid2>
    );
  };
  return EnumFormFields;
};

export default getEnumFormField;
